export enum TypeLastAccess {
	CHAT = 1
}
